module.exports = __webpack_public_path__ + "static/media/22.e4ad899c.svg";